import { API_BASE_URL, API_DELETE_USER_PROFILE } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export interface getDeleteUserProfileResponse {
    message: string;
}

async function executeGetDeleteUserProfileWithToken(accessToken: string | null): Promise<getDeleteUserProfileResponse> {
    return axios
        .get(
            API_BASE_URL + API_DELETE_USER_PROFILE,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else {
                console.error('Error during vote:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetDeleteUserProfileWithToken(accessToken: string | null): Promise<getDeleteUserProfileResponse> {

    return executeGetDeleteUserProfileWithToken(accessToken)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetDeleteUserProfileWithToken(refreshedAccessToken);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
